import { gql } from '@apollo/client';

export const GET_AGENCY = gql`
  query GetAgency($name: String!) {
    agency(name: $name) {
      id
      name
      subdomain
      logo
      description
      address
      phone
      email
      website
      facebook
      instagram
      tiktok
      theme {
        primaryColor
        secondaryColor
        textColor
        heroTextColor
      }
    }
  }
`;

export const GET_AGENCIES = gql`
  query GetAgencies {
    agencies {
      id
      name
      subdomain
      logo
      description
      address
      phone
      email
      website
      verified
      theme {
        primaryColor
        secondaryColor
        accentColor
        textColor
        backgroundColor
        heroTextColor
        headerStyle
        font
      }
      popularDestinations {
        id
        name
        image
        price
      }
      yearsExperience
      satisfiedTravelers
      rating
      reviewCount
    }
  }
`;

export const GET_AGENCY_PAGE_DATA = gql`
  query GetAgencyPageData($subdomain: String!) {
    agencyPageData(subdomain: $subdomain) {
      id
      name
      subdomain
      logo
      description
      address
      phone
      email
      website
      facebook
      instagram
      tiktok
      firstTitle
      secondTitle
      imageCover
      theme {
        primaryColor
        secondaryColor
        accentColor
        textColor
        backgroundColor
        heroTextColor
        headerStyle
        font
      }
      popularDestinations {
        id
        name
        image
        price
      }
      aboutImage
      yearsExperience
      expertise
      satisfiedTravelers
      prestations
      packages {
        id
        title
        description
        image
        departure
        category
        type
        airline {
          id
          name
          code
          logo
        }
        departures {
          id
          departureDate
          returnDate
        }
        formulas {
          id
          name
          priceType
          perPersonPrice
          roomPrices {
            single
            double
            triple
            quadruple
            quintuple
          childWithBed
          childWithoutBed
          baby
          }
          hotels {
            id
            name
            stars
            image
            address
            amenities
            meals
            bookingUrl
          }
        }
      }
    }
  }
`;

export const GET_AGENCY_PAGE_DATA_BY_ID = gql`
  query GetAgencyPageDataById($id: Int!) {
    agencyPageDataById(id: $id) {
      id
      name
      subdomain
      logo
      description
      address
      phone
      email
      website
      facebook
      instagram
      tiktok
      firstTitle
      secondTitle
      imageCover
      theme {
        primaryColor
        secondaryColor
        accentColor
        textColor
        backgroundColor
        heroTextColor
        headerStyle
        font
      }
      popularDestinations {
        id
        name
        image
        price
      }
      aboutImage
      yearsExperience
      expertise
      satisfiedTravelers
      prestations
      packages {
        id
        title
        description
        image
        departure
        category
        type
        airline {
          id
          name
          code
          logo
        }
        departures {
          id
          departureDate
          returnDate
        }
        formulas {
          id
          name
          priceType
          perPersonPrice
          roomPrices {
            single
            double
            triple
            quadruple
            quintuple
          childWithBed
          childWithoutBed
          baby
          }
          hotels {
            id
            name
            stars
            image
            address
            amenities
            meals
            bookingUrl
          }
        }
      }
    }
  }
`;

export const GET_AGENCY_BY_NAME = gql`
  query GetAgencyByName($name: String!) {
    agency(name: $name) {
      id
      name
    }
  }
`; 